module.exports = __webpack_public_path__ + "img/viewdocuments.19bba16a.svg";